import React from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import "./admin-auth.scss";
import { signIn } from "../../../requests/authApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      console.log("Login form submitted:", values);
      try {
        const { email, password } = values;
        const data = await signIn({ email, password });
        if(data.status) {
        localStorage.setItem("teleport_admin_token", data.data.token);
        localStorage.setItem("teleport_admin_data", data.data.userId);

        navigate("/user-information");
        } else {
          toast.error(data.message)
        }
      } catch (err) {
        throw err;
      }
    },
  });

  return (
    <section className="admin-auth-section">
      <div className="row align-items-md-center g-0">
        <div className="col-md-6 d-md-block d-none">
          <div className="img-wrap">
            <Link to="/">
              <img
                src="/images/admin-logo.svg"
                width={100}
                height={100}
                alt="Logo"
              />
            </Link>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row justify-content-center g-0">
            <div className="col-lg-10">
              <form onSubmit={formik.handleSubmit} className="auth-form">
                <div className="heading">
                  <h2>Log In</h2>
                </div>

                {/* Email */}
                <div className="input-wrap">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="error">{formik.errors.email}</div>
                  )}
                </div>

                {/* Password */}
                <div className="input-wrap">
                  <label>Password</label>
                  <input
                    type="password"
                    name="password"
                    placeholder="Enter password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className="error">{formik.errors.password}</div>
                  )}
                </div>

                <button className="custom-btn" type="submit">
                  Log In
                </button>

                {/* Social Auth */}
                <div className="social-auth">
                  <div className="divider">
                    <span>Or</span>
                  </div>
                  <div className="social-icons">
                    <button className="social-btn google" type="button">
                      <img src="/images/icons/google.svg" alt="google" />
                      <span>Sign in With Google</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
